import React, { useEffect } from "react";
import * as styles from "./JobSelection.module.scss";
import classNames from "classnames";
import Select from "@app/components/Select";
import InputErrorMessage from "@app/components/InputErrorMessage";

const JobSelection = ({ jobs = [], field, form, label, hasError, required, ...selectProps }) => {
	const jobSelectionClassName = classNames({
		[styles["job-selection"]]: true,
	});

	const options = jobs.map((job) => ({
		value: job.label,
		label: job.label,
	}));

	const originalOnChange = selectProps.onChange;

	const handleChange = (value, option) => {
		form.setFieldValue(field.name, value);
		form.setFieldValue(`${field.name}__ID`, jobs.find((item) => item.label === value).id);
		originalOnChange?.(value, option);
	};

	useEffect(() => {
		if (field.value && !field.touched) {
			form.setFieldTouched(field.name, true);
		}
	}, [field.value]);

	const errorMessage = form.errors?.[field.name];

	return (
		<div className={jobSelectionClassName}>
			<Select
				label={label}
				options={options}
				isSearchable
				placeholder="Bitte wählen"
				field={field}
				form={form}
				onChange={handleChange}
				{...selectProps}
			/>
			<InputErrorMessage show={Boolean(errorMessage) && field.touched} msg={errorMessage} />
		</div>
	);
};

JobSelection.propTypes = {};

export default JobSelection;
